const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "c031acea785cd058803c35266dacdaaf4af4ed8d-Ubuntu7Standard:a50673f5-b5d8-44ab-a74c-03f7ecc6d621",
};

export default sentryConfig;
